import {DateInput, ListProps,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {getDefaultListProps, initField, initInput} from "../../shared/utils";
import {CustomList} from "../../components/CustomList";
import {ReconciliationFileDatagrid} from "./ReconciliationFIleDatagrid";
import {AutocompleteInput, ReferenceInput, TextInput} from "react-admin";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";


export const ReconciliationFileList = (props: ListProps) => {
    const {data: options} = useOptions("reconciliation_file", "GET");

    const filters = options ? [
        <DateInput
            alwaysOne
            {...initField("date", options)}
            label="Data"
        />,
        <TextInput {...initField("file", options)}/>,
        <ReferenceInput
            {...initField("bank", options)}
            reference="autocomplete/bank"
            className="filter-field-small"
            label="Banca"
        >
            <AutocompleteInput optionText="label"/>
        </ReferenceInput>,
    ] : []


    return options ?
        <CustomList
            filters={filters}
            {...getDefaultListProps(props)}>
            <ReconciliationFileDatagrid options={options}/>
        </CustomList>
        : null;
};
